"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = exports.Title = exports.Content = exports.Body = exports.Header = exports.Dialog = void 0;
const native_1 = __importDefault(require("styled-components/native"));
const Typography_1 = require("../../atoms/Typography/Typography");
exports.Dialog = native_1.default.SafeAreaView `
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.bpCore.colors.white};
  box-shadow: 0 40px 30px rgba(35, 35, 35, 0.26);
`;
exports.Header = native_1.default.View ``;
exports.Body = native_1.default.View ``;
exports.Content = native_1.default(Typography_1.PText) `
  margin-top: ${({ hasTitle }) => (hasTitle ? '0' : '24')}px;
  margin-right: 16px;
  margin-bottom: 24px;
  margin-left: 16px;
  text-align: center;
  color: ${({ theme }) => theme.bpCore.colors.dark[400]};
`;
exports.Title = native_1.default(Typography_1.PText) `
  margin: 24px 16px 2px 16px;
  text-align: center;
  color: ${({ theme }) => theme.bpCore.colors.text};
`;
exports.Footer = native_1.default.View `
  flex-direction: row;
  height: 56px;
  width: 100%;
  align-items: center;
  border-top-width: 1px;
  border-top-color: ${({ theme }) => theme.bpCore.colors.neutral[200]};
`;
